import type * as Types from 'connect-graphql/generated';
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type SearchQueryVariables = Types.Exact<{
  searchValue: Types.Scalars['String']['input'];
}>;


export type SearchQuery = { __typename?: 'Query', searchContent: Array<{ __typename?: 'AssignedActivity', id: string, name: string, description?: string | null, status: Types.ActivityStatus, dueDate?: any | null, latestScore?: number | null, timeSpentOnActivity?: { __typename?: 'TimeSpent', hours: number, minutes: number } | null, latestEvaluator?: { __typename?: 'UserProfile', id: string } | null, learner: { __typename?: 'UserProfile', id: string } }> };


export const SearchDocument = gql`
    query Search($searchValue: String!) {
  searchContent(searchValue: $searchValue) {
    id
    name
    description
    status
    timeSpentOnActivity {
      hours
      minutes
    }
    dueDate
    latestScore
    latestEvaluator {
      id
    }
    learner {
      id
    }
  }
}
    `;

export function useSearchQuery(options: Omit<Urql.UseQueryArgs<SearchQueryVariables>, 'query'>) {
  return Urql.useQuery<SearchQuery, SearchQueryVariables>({ query: SearchDocument, ...options });
};